// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__vv1Xq","ranges":"BmiRanges_ranges__1xWQL"};